import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { FeatureEndpoint, Url } from "../../Type/BaseUrl";

const FeatureService = createApi({
	reducerPath: "FeatureService",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			featureContent: builder.query({
				query: () => {
					return {
						url: FeatureEndpoint,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useFeatureContentQuery } = FeatureService;
export default FeatureService;
